package uz.ferro.erp

import js.objects.jso
import react.create
import react.router.dom.createHashRouter
import uz.ferro.erp.feature.appuser.ui.UserListPage
import uz.ferro.erp.feature.customer.ui.CustomerListPage
import uz.ferro.erp.feature.visit.ui.VisitListPage
import uz.ferro.erp.feature.faq.ui.FaqPage
import uz.ferro.erp.feature.home.ui.HomeDashboard
import uz.ferro.erp.feature.order.ui.OrderDetailsPage
import uz.ferro.erp.feature.order.ui.OrderListPage
import uz.ferro.erp.feature.product.ui.ProductDetailsPage
import uz.ferro.erp.feature.product.ui.ProductListPage
import uz.ferro.erp.feature.task.ui.TaskListPage
import uz.ferro.erp.pages.home.Home
import uz.ferro.erp.pages.login.LoginPage

val appRouter = createHashRouter(
    arrayOf(
        jso {
            path = "/"
            element = Root.create()
            children = arrayOf(
                jso {
                    index = true
                    element = Home.create()
                }
            )
        },
        jso {
            path = "board"
            element = HomeDashboard.create()
            children = arrayOf(
                jso {
                    path = "visit"
                    element = VisitListPage.create()
                },
                jso {
                    path = "customer"
                    element = CustomerListPage.create()
                },
                jso {
                    path = "user"
                    element = UserListPage.create()
                },
                jso {
                    path = "task"
                    element = TaskListPage.create()
                }
            )
        },

        jso {
            path = "product/:productId"
            element = ProductDetailsPage.create()
        },

        jso {
            path = "products"
            element = ProductListPage.create()
        },

        jso {
            path = "orders"
            element = OrderListPage.create()
        },

        jso {
            path = "order/:orderId"
            element = OrderDetailsPage.create()
        },

        jso {
            path = "faq"
            element = FaqPage.create()
        },

        jso {
            path = "login"
            element = LoginPage.create()
        },

//        jso {
//            path = "admin"
//            element = AdminDashboard.create()
//            children = arrayOf(
//                jso {
//                    path = "user"
//                    element = OutletContainer.create()
//                    children = arrayOf(
//                        jso {
//                            index = true
//                            element = AdminUserList.create()
//                        },
//                        jso {
//                            path = ":userId"
//                            element = AdminEditUser.create()
//                        }
//                    )
//                },
//                jso {
//                    path = "home"
//                    element = AdminHomePage.create()
//                },
//                jso {
//                    path = "component/:componentId"
//                    element = OutletContainer.create()
//                    children = arrayOf(
//                        jso {
//                            path = "component-country/:componentCountryId"
//                            element = AdminComponentCountry.create()
//                        },
//                        jso {
//                            path = "component-product/:componentProductId"
//                            element = AdminComponentProduct.create()
//                        }
//                    )
//                },
//                jso {
//                    path = "order"
//                    element = OutletContainer.create()
//                    children = arrayOf(
//                        jso {
//                            index = true
//                            element = AdminOrderList.create()
//                        },
//                        jso {
//                            path = ":orderId"
//                            element = AdminOrderDetails.create()
//                        }
//                    )
//                },
//                jso {
//                    path = "product"
//                    element = OutletContainer.create()
//                    children = arrayOf(
//                        jso {
//                            index = true
//                            element = AdminProductList.create()
//                        },
//                        jso {
//                            path = ":productId"
//                            element = AdminEditProduct.create()
//                        }
//                    )
//                },
//                jso {
//                    path = "exchange-rate"
//                    element = AdminExchangeRate.create()
//                }
//            )
//        }
    )
)
